
import { reactive} from "vue";
import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";

export default {
  name: "FishBookEntryLeasing",
  inheritAttrs: false,
  components: {
    DynamicForm
  },
  setup() {
    const request = reactive({
      apiLoadMethod: "",
      apiSaveMethod: "",
      form: "FischbuchEintragPacht",
      page: "FischbuchEintragPachtDaten",
      remoteId: "",
      
      

    });
    return {
      request
    };
  }
};
